<template>
  <SfModal v-if="showModal" size="xs" @close="closeModal">
    <template #title>
      {{ confirmTitleLabel }}
    </template>

    <template #body>
      <div class="center">
        {{ confirmDescriptionLabel }}
      </div>
    </template>

    <template #messages-bottom>
      <BlockProposals
        v-if="showProposalBlocking"
        :workflow-name="workflowName"
        :proposals-blocked="proposalsBlocked"
        @toggle-proposal-blocking="toggleProposalsBlocked"
      />
    </template>

    <template #footer>
      <SfButtonDs @click="closeModal">
        {{ I18n.t('common.cancel') }}
      </SfButtonDs>
      <SfButtonDs variant="danger" @click="confirm">
        {{ confirmButtonLabel }}
      </SfButtonDs>
    </template>
  </SfModal>
</template>

<script type="text/javascript">
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import BlockProposals from './block-proposals.vue'
import { SfLog } from '@app/adapters/logger'
import { SfModal } from '@app/shared/vue/components/sf-modal'
import SFetch from '@app/utils/sfetch'

export default {
  name: 'ConfirmDeclineReconciliationProposalModal',
  components: { SfModal, BlockProposals, SfButtonDs },
  data() {
    return {
      showModal: true,
      objName: null,
      objType: null,
      objSource: null,
      confirmUrl: null,
      workflowName: '',
      showProposalBlocking: false,
      proposalsBlocked: false,
      workflowId: null,
    }
  },
  computed: {
    confirmButtonLabel() {
      if (!this.showProposalBlocking) {
        return I18n.t('reconciliation_proposal.confirm.decline_changes')
      }

      if (this.proposalsBlocked) {
        return I18n.t(
          'reconciliation_proposal.actions.decline_and_block_further_proposals'
        )
      } else {
        return I18n.t(
          'reconciliation_proposal.actions.decline_and_allow_further_proposals'
        )
      }
    },
    confirmTitleLabel() {
      return I18n.t(
        `reconciliation_proposal.confirm.${this.proposalSourceLabel}.decline_title`
      )
    },
    confirmDescriptionLabel() {
      const details = { name: this.objName, type: this.objType }
      return I18n.t(
        `reconciliation_proposal.confirm.${this.proposalSourceLabel}.decline`,
        details
      )
    },
    proposalSourceLabel() {
      return ['ai_check', 'ai_input_automation', 'ai_chat'].includes(
        this.objSource
      )
        ? 'ai'
        : this.objSource
    },
  },
  methods: {
    openModal({
      objName,
      objType,
      objSource,
      url,
      workflowName,
      showProposalBlocking,
      proposalsBlocked,
      workflowId,
    }) {
      this.showModal = true
      this.objName = objName
      this.objType = objType
      this.objSource = objSource
      this.confirmUrl = url
      this.workflowName = workflowName
      this.showProposalBlocking = showProposalBlocking
      this.proposalsBlocked = proposalsBlocked
      this.workflowId = workflowId
    },
    closeModal() {
      this.showModal = false
    },
    toggleProposalsBlocked() {
      this.proposalsBlocked = !this.proposalsBlocked
    },
    confirm() {
      const url = this.confirmUrl
      const data = [
        { key: 'block_proposals', value: this.proposalsBlocked },
        { key: 'company_workflow_id', value: this.workflowId },
      ]

      try {
        SFetch.postFormRedirect({
          url,
          method: 'POST',
          authenticityToken: Silverfin.csrfToken(),
          data,
        })
      } catch (e) {
        SfLog.warn('Failed to confirm reconciliation proposal', {
          extra: {
            error: e,
          },
        })
      }
      this.closeModal()
    },
  },
}
</script>
